module.exports = __webpack_public_path__ + "img/development_01.56beb929.png";